import { type Theme } from "@repo/tokens";

/**
 * Resolves a dot-notation path (e.g., "surface.card") to a value from the theme.
 * Falls back to the raw value if the path doesn't exist in the theme.
 */
export function resolveThemeToken(
  theme: Theme | undefined,
  path: string | undefined,
): string | undefined {
  if (!theme || !path) return path;

  // 1. Check if it's a direct key (performance optimization)
  if (path in (theme as unknown as Record<string, unknown>)) {
    return String((theme as unknown as Record<string, unknown>)[path]);
  }

  // 2. Handle dot notation (e.g., "surface.card", "action.primary.default")
  const keys = path.split(".");
  let current: unknown = theme;

  for (const key of keys) {
    if (
      current &&
      typeof current === "object" &&
      key in (current as Record<string, unknown>)
    ) {
      current = (current as Record<string, unknown>)[key];
    } else {
      // Path not found, return original value (fallback for raw hex codes)
      return path;
    }
  }

  return typeof current === "string" || typeof current === "number"
    ? String(current)
    : path;
}
